import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
// import { resolve } from "core-js/fn/promise"
import rebuildRoutes from './rebuild';

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: resolve => require(['@/views/login/index'], resolve),
        },
        {
            path: '/register',
            name: 'register',
            component: resolve => require(['@/views/login/register'], resolve),
        }, {
            path: '/resetpwd',
            name: 'resetpwd',
            component: resolve => require(['@/views/login/resetpwd'], resolve),

        },
        {
            path: '/',
            name: 'index',
            redirect: '/home',
        },
        {
            path: '/home',
            name: 'home',
            component: resolve => require(['@/views/index'], resolve),
        },
        {
            path: '/companyProfile',
            name: 'companyProfile',
            component: resolve => require(['@/views/companyProfile/index'], resolve),
        },
        {
            path: '/infoDetails',
            name: 'infoDetails',
            component: resolve => require(['@/views/infoDetails/index'], resolve),
        },
        {
            path: '/article',
            name: 'article',
            component: resolve => require(['@/views/article/index'], resolve),
        },
        {
            path: '/driver',
            name: 'driver',
            meta: {
                role: 'DRIVER',
            },
            component: resolve => require(['@/views/driver/index'], resolve),
            children: [
                {
                    path: '/',
                    redirect: '/driver/drive-settled',
                },
                {
                    path: '/driver/drive-settled',
                    name: 'drive-settled',
                    meta: {
                        role: 'DRIVER',
                        redirectUrl: '/driver-center',
                    },
                    component: resolve =>
                        require(['@/views/driver/driver-settled'], resolve),
                },
                {
                    path: '/driver/contract',
                    name: 'driver-contract',
                    meta: {
                        role: 'DRIVER',
                    },
                    component: resolve => require(['@/views/common/contract'], resolve),
                },
                {
                    path: '/driver/transportList',
                    name: 'driver-transportList',
                    meta: {
                        role: 'DRIVER',
                    },
                    component: resolve =>
                        require(['@/views/common/transportList'], resolve),
                },
                {
                    path: '/driver/billList',
                    name: 'driver-billList',
                    meta: {
                        role: 'DRIVER',
                    },
                    component: resolve => require(['@/views/common/billList'], resolve),
                },
                {
                    path: '/driver/transportList',
                    name: 'driver-transportList',
                    meta: {
                        role: 'DRIVER',
                    },
                    component: resolve =>
                        require(['@/views/common/transportList'], resolve),
                },
                {
                    path: '/driver/carManagement',
                    name: 'car-management',
                    meta: {
                        role: 'DRIVER',
                    },
                    component: resolve =>
                        require(['@/views/driver/car-management'], resolve),
                },
                {
                    path: '/driver/orderGrabbing',
                    name: 'order-grabbing',
                    meta: {
                        role: 'DRIVER',
                    },
                    component: resolve =>
                        require(['@/views/driver/order-grabbing'], resolve),
                },
                {
                    path: '/driver/emptyCarRelease',
                    name: 'emptyCarRelease',
                    meta: {
                        role: 'DRIVER',
                    },
                    component: resolve =>
                        require(['@/views/driver/emptyCarRelease'], resolve),
                },
            ],
        },
        {
            path: '/carriers',
            name: 'carriers',
            meta: {
                role: 'CARRIERS',
            },
            component: resolve => require(['@/views/carriers/index'], resolve),
            children: [
                {
                    path: '/',
                    redirect: '/carriers/carriers-settled',
                },
                {
                    path: '/carriers/carriers-settled',
                    name: 'carriers-settled',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/consignor/consignor-settled'], resolve),
                },
                {
                    path: '/carriers/waybill',
                    name: 'waybill',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve => require(['@/views/common/waybill'], resolve),
                },
                {
                    path: '/carriers/contract',
                    name: 'contract',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve => require(['@/views/common/contract'], resolve),
                },
                {
                    path: '/carriers/pound-bill',
                    name: 'pound-bill',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve => require(['@/views/common/waybill'], resolve),
                },
                {
                    path: '/carriers/batchImport',
                    name: 'batchImport',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve => require(['@/views/carriers/carriers'], resolve),
                },
                {
                    path: '/carriers/offerOrderList/:type',
                    name: 'offerOrderList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/offer-order-list'], resolve),
                },
                {
                    path: '/carriers/stayOfferList',
                    name: 'stayOfferList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/stay-offer-list'], resolve),
                },
                {
                    path: '/carriers/transportList',
                    name: 'transportList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/common/transportList'], resolve),
                },
                {
                    path: '/carriers/billList',
                    name: 'billList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve => require(['@/views/common/billList'], resolve),
                },
                {
                    path: '/carriers/logisticsOrderList/:type',
                    name: 'logisticsOrderList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/logistics-order-list'], resolve),
                },
                // 普货车辆/司机录入
                {
                    path: '/carriers/ordinaryInfo',
                    name: 'ordinaryInfo',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require([
                            '@/views/rebuild/carriers/ordinaryInfo',
                        ], resolve),
                },
                // 普货车辆/司机录入
                {
                    path: '/carriers/ordinaryInfoList',
                    name: 'ordinaryInfo',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require([
                            '@/views/rebuild/carriers/ordinaryInfoList',
                        ], resolve),
                },
                // 危化品人员信息
                {
                    path: '/carriers/hazardousChemicals',
                    name: 'hazardousChemicals',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require([
                            '@/views/rebuild/carriers/hazardousChemicals',
                        ], resolve),
                },
                // 危化品人员列表
                {
                    path: '/carriers/hazardousChemicalsList',
                    name: 'hazardousChemicalsList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require([
                            '@/views/rebuild/carriers/hazardousChemicalsList',
                        ], resolve),
                },
                // 火车委托单列表
                {
                    path: '/carriers/trainDailyPlan',
                    name: 'trainDailyPlanList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/trainDailyPlan'], resolve),
                },
                // 创建火车日计划
                {
                    path: '/carriers/createTrainDailyPlan',
                    name: 'createTrainDailyPlan',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/createTrainDailyPlan'], resolve),
                },
                // 火车日计划列表
                {
                    path: '/carriers/trainDailyPlanList',
                    name: 'trainDailyPlanList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/trainDailyPlanList'], resolve),
                },
                // 火车装车确认
                {
                    path: '/carriers/trainConfirmLoading',
                    name: 'trainConfirmLoading',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/trainConfirmLoading'], resolve),
                },
                // 离场过账
                {
                    path: '/carriers/departurePostingList',
                    name: 'departurePostingList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/departurePostingList'], resolve),
                },
                // 火车离场过账
                {
                    path: '/carriers/departurePosting',
                    name: 'departurePosting',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/departurePosting'], resolve),
                },
                // 确认到达
                {
                    path: '/carriers/confiemedArriveList',
                    name: 'confiemedArriveList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/confiemedArriveList'], resolve),
                },
                // 到达确认
                {
                    path: '/carriers/confiemedArrive',
                    name: 'confiemedArrive',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/confiemedArrive'], resolve),
                },
                // 火车入库通知单导入
                {
                    path: '/carriers/trainEntryNoticeImport',
                    name: 'trainEntryNoticeImport',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/trainEntryNoticeImport'], resolve),
                },
                // 火车过账信息导入磷化集团数字工厂
                {
                    path: '/carriers/trainPostingInfoImport',
                    name: 'trainPostingInfoImport',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/trainPostingInfoImport'], resolve),
                },
                // 数字工厂汽车导入
                {
                    path: '/carriers/digitalFactoryImport',
                    name: 'trainPostingInfoImport',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/digitalFactoryImport'], resolve),
                },
                // 汽车运输单导入
                {
                    path: '/carriers/carTransportImport',
                    name: 'carTransportImport',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/carTransportImport'], resolve),
                },
                {
                    path: '/carriers/sapCarTransportImport',
                    name: "sapCarTransportImport",
                    meta: {
                        role: "CARRIERS"
                    },
                    component: resolve => require(["@/views/rebuild/carriers/sapCarTransportImport"], resolve)
                },
                //
                {
                    path: '/carriers/driverInfoImport',
                    name: 'driverInfoImport',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/carriers/driverInfoImport'], resolve),
                },
                {
                    path: '/carriers/transportOrderList/:type',
                    name: 'transportOrderList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/transport-order-list'], resolve),
                },
                {
                    path: '/carriers/subAccount',
                    name: 'carriers-subAccount',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve => require(['@/views/common/subAccount'], resolve),
                },
                {
                    path: '/carriers/transportForThe',
                    name: 'transportForThe',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/transport-for-the'], resolve),
                },
                {
                    path: '/carriers/carManagement',
                    name: 'carManagement',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/car-management'], resolve),
                },
                {
                    path: '/carriers/driverManagement',
                    name: 'driverManagement',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/driver-management'], resolve),
                },
                {
                    path: '/carriers/transportGroup',
                    name: 'transportGroup',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/transportGroup'], resolve),
                },
                {
                    path: '/carriers/contractsList/:type',
                    name: 'contractsList',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/common/contracts-list'], resolve),
                },
                {
                    path: '/carriers/homePagePreview',
                    name: 'homePagePreview',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/portal/home-page-preview'], resolve),
                },
                {
                    path: '/carriers/parameterMaintenance',
                    name: 'carrierParameterMaintenance',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/portal/carrier-parameter-maintenance'], resolve),
                },
                {
                    path: '/carriers/operationManual',
                    name: 'operationManual',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/portal/operation-manual'], resolve),
                },
                {
                    path: '/carriers/onlineService',
                    name: 'onlineService',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/portal/online-service'], resolve),
                },
                {
                    path: '/carriers/carriersTransactionStatistics',
                    name: 'carriersTransactionStatistics',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/carriersTransactionStatistics'], resolve),
                },
                {
                    path: '/carriers/materialInfo',
                    name: 'materialInfo',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/material-info'], resolve),
                },
                {
                    path: '/carriers/subAccountRegistration',
                    name: 'subAccountRegistration',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require([
                            '@/views/userManagement/sub-account-registration',
                        ], resolve),
                },
                {
                    path: '/carriers/creditManagement',
                    name: 'creditManagement',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/userManagement/credit-management'], resolve),
                },
                {
                    path: '/carriers/statisticalAnalysis',
                    name: 'statisticalAnalysis',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/userManagement/carriers-statistics'], resolve),
                },
                {
                    path: '/carriers/carriersMangement',
                    name: 'carriersMangement',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/userManagement/carriers-mangement'], resolve),
                },
                {
                    path: '/carriers/evaluation',
                    name: 'evaluation',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/userManagement/evaluation'], resolve),
                },
                {
                    path: '/carriers/driverBindingCarrier',
                    name: 'driverBindingCarrier',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/driver-binding-carrier'], resolve),
                },
                {
                    path: '/carriers/driverBindingVehicle',
                    name: 'driverBindingVehicle',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/driver-binding-vehicle'], resolve),
                },
                {
                    path: '/carriers/trailerBindingVehicle',
                    name: 'trailerBindingVehicle',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/trailer-binding-vehicle'], resolve),
                },
                {
                    path: '/carriers/carStatistics',
                    name: 'carStatistics',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/carStatistics'], resolve),
                },
                {
                    path: '/carriers/transactionQuery',
                    name: 'transactionQuery',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/contractManagement/transaction-query'], resolve),
                },
                {
                    path: '/carriers/executionTracking',
                    name: 'executionTracking',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/contractManagement/carriers-execution-tracking'], resolve),
                },
                {
                    path: '/carriers/detailedReport',
                    name: 'detailedReport',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/detailed-report'], resolve),
                },
                // 火车明细
                {
                    path: '/carriers/TrainDetailedReport',
                    name: 'detailedReport',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve => require(['@/views/rebuild/carriers/trainDetailedReport'], resolve),
                },
                {
                    path: '/carriers/summaryReport',
                    name: 'summaryReport',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/waybill/summary-report'], resolve),
                },
                {
                    path: '/carriers/certificateEarlyWarning',
                    name: 'certificateEarlyWarning',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/security/carriers-certificate-warning'], resolve),
                },
                {
                    path: '/carriers/subCertificateWarning',
                    name: 'subCertificateWarning',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/security/sub-certificate-warning'], resolve),
                },
                {
                    path: '/carriers/driverCertificateWarning',
                    name: 'driverCertificateWarning',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/security/driver-certificate-warning'], resolve),
                },
                {
                    path: '/carriers/carCertificateWarning',
                    name: 'carCertificateWarning',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/security/car-certificate-warning'], resolve),
                },
                {
                    path: '/carriers/creditEarlyWarning',
                    name: 'creditEarlyWarning',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/security/credit-early-warning'], resolve),
                },
                {
                    path: '/carriers/quotaUsageReminder',
                    name: 'quotaUsageReminder',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/security/quota-usage-reminder'], resolve),
                },
                {
                    path: '/carriers/authorizationAlert',
                    name: 'authorizationAlert',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/security/authorization-alert'], resolve),
                },
                {
                    path: '/carriers/competitiveNegotiation',
                    name: 'competitiveNegotiation',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/competitive-negotiation'], resolve),
                },
                {
                    path: '/carriers/bidInvitationManagement',
                    name: 'bidInvitationManagement',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/bid-invitation-management'], resolve),
                },
                {
                    path: '/carriers/transactionStatisticalAnalysis',
                    name: 'transactionStatisticalAnalysis',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require([
                            '@/views/carriers/transaction-statistical-analysis',
                        ], resolve),
                },
                {
                    path: '/carriers/delegatedOrder',
                    name: 'delegatedOrder',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/delegated-order'], resolve),
                },
                {
                    path: '/carriers/consignmentExecutionTracking',
                    name: 'consignmentExecutionTracking',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require([
                            '@/views/carriers/consignment-execution-tracking',
                        ], resolve),
                },
                {
                    path: '/carriers/splitOrder',
                    name: 'splitOrder',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/split-order'], resolve),
                },
                {
                    path: '/carriers/transportationTracking',
                    name: 'transportationTracking',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/transportation-tracking'], resolve),
                },
                {
                    path: '/carriers/ticketIssuing',
                    name: 'ticketIssuing',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/common/ticket-issuing'], resolve),
                },
                {
                    path: '/carriers/receiptAndPayment/:type',
                    name: 'receiptAndPayment',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/common/receipt-and-payment'], resolve),
                },
                {
                    path: '/carriers/settlementStatisticalAnalysis',
                    name: 'settlementStatisticalAnalysis',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require([
                            '@/views/carriers/settlement-statistical-analysis',
                        ], resolve),
                },
                {
                    path: '/carriers/complaint',
                    name: 'complaint',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve => require(['@/views/carriers/complaint'], resolve),
                },
                {
                    path: '/carriers/resultFeedback',
                    name: 'resultFeedback',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/result-feedback'], resolve),
                },
                {
                    path: '/carriers/dataForwarding',
                    name: 'dataForwarding',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/data-forwarding'], resolve),
                },
                {
                    path: '/carriers/dataSigning',
                    name: 'dataSigning',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/data-signing'], resolve),
                },
                {
                    path: '/carriers/testPaperSigning',
                    name: 'testPaperSigning',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/test-paper-signing'], resolve),
                },
                {
                    path: '/carriers/onlineExamination',
                    name: 'onlineExamination',
                    meta: {
                        role: 'CARRIERS',
                    },
                    component: resolve =>
                        require(['@/views/carriers/online-examination'], resolve),
                },
            ],
        },
        {
            path: '/consignor',
            name: 'consignor',
            meta: {
                role: 'CUSTOMER',
            },
            component: resolve => require(['@/views/consignor/index'], resolve),
            children: [
                {
                    path: '/',
                    redirect: '/consignor/consignor-settled',
                },
                {
                    path: '/consignor/consignor-settled',
                    name: 'consignor-settled',
                    meta: {
                        role: 'CUSTOMER',
                        redirectUrl: '/consignor-center',
                    },
                    component: resolve =>
                        require(['@/views/consignor/consignor-settled'], resolve),
                },
                {
                    path: '/consignor/place-order',
                    name: 'place-order',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/place-order'], resolve),
                },
                {
                    path: '/consignor/newDelegationForm',
                    name: 'newDelegationForm',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/place-order'], resolve),
                },
                {
                    path: '/consignor/pound-bill',
                    name: 'pound-bill',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve => require(['@/views/common/waybill'], resolve),
                },
                {
                    path: '/consignor/waybill',
                    name: 'waybill',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve => require(['@/views/common/waybill'], resolve),
                },
                {
                    path: '/consignor/contract',
                    name: 'contract',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve => require(['@/views/common/contract'], resolve),
                },
                {
                    path: '/consignor/demandList',
                    name: 'demandList',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/demand-list'], resolve),
                },
                {
                    path: '/consignor/transportList',
                    name: 'transportList',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        // require(["@/views/common/transportList"], resolve)
                        require(['@/views/carriers/transport-for-the'], resolve),
                },
                {
                    path: '/consignor/billList',
                    name: 'billList',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve => require(['@/views/common/billList'], resolve),
                },
                {
                    path: '/consignor/subAccount',
                    name: 'consignor-subAccount',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve => require(['@/views/common/subAccount'], resolve),
                },
                {
                    path: '/consignor/contractsList/:type',
                    name: 'contractsList',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/common/contracts-list'], resolve),
                },
                // --菜单配置
                // 门户管理-主页预览
                // 主页
                {
                    path: '/consignor/homePagePreview',
                    name: 'homePagePreview',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/portal/home-page-preview'], resolve),
                },
                // 参数维护
                {
                    path: '/consignor/parameterMaintenance',
                    name: 'parameterMaintenance',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/portal/parameter-maintenance'], resolve),
                },
                // 常用物料明细表
                {
                    path: '/consignor/materialInfo',
                    name: 'materialInfo',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/material-info'], resolve),
                },
                // 客服中心-操作手册
                {
                    path: '/consignor/operationManual',
                    name: 'operationManual',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/portal/operation-manual'], resolve),
                },
                // 客服中心-在线客服
                {
                    path: '/consignor/onlineService',
                    name: 'onlineService',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/portal/online-service'], resolve),
                },
                {
                    path: '/consignor/customerTransactionStatistics',
                    name: 'customerTransactionStatistics',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/customerTransactionStatistics'], resolve),
                },
                // 用户管理-注册管理
                // 注册子账号
                {
                    path: '/consignor/subAccountRegistration',
                    name: 'subAccountRegistration',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require([
                            '@/views/userManagement/sub-account-registration',
                        ], resolve),
                },

                // 查询统计-授信管理
                {
                    path: '/consignor/creditManagement',
                    name: 'creditManagement',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/userManagement/credit-management'], resolve),
                },
                // 查询统计-授信管理
                {
                    path: '/consignor/statisticalAnalysis',
                    name: 'statisticalAnalysis',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/userManagement/owner-statistics'], resolve),
                },
                {
                    path: '/consignor/ownerMangement',
                    name: 'ownerMangement',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/userManagement/owner-mangement'], resolve),
                },
                // 评价管理-编辑发布
                {
                    path: '/consignor/evaluation',
                    name: 'evaluation',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/userManagement/evaluation'], resolve),
                },
                // -交易管理
                // 交易管理-统计分析
                {
                    path: '/consignor/carriers/statisticalAnalysis',
                    name: 'statisticalAnalysis',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/statistical-analysis'], resolve),
                },
                // -合同管理-查询管理
                // 交易查询
                {
                    path: '/consignor/transactionQuery',
                    name: 'transactionQuery',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/contractManagement/transaction-query'], resolve),
                },
                // 执行追踪
                {
                    path: '/consignor/executionTracking',
                    name: 'executionTracking',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/contractManagement/execution-tracking'], resolve),
                },
                // 货主火车入库通知单导入
                {
                    path: '/consignor/trainEntryNoticeImport',
                    name: 'trainEntryNoticeImport',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/consignor/trainEntryNoticeImport'], resolve),
                },
                {
                    path: '/consignor/carTransportImport',
                    name: 'carTransportImport',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/rebuild/consignor/carTransportImport'], resolve),
                },
                //
                //-运单管理-统计分析
                // 创建与发布
                {
                    path: '/consignor/delegationOrderCreation',
                    name: 'delegationOrderCreation',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/delegation-order-creation'], resolve),
                },
                // 执行追踪
                {
                    path: '/consignor/delegation/executionTracking',
                    name: 'executionTracking',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/execution-tracking'], resolve),
                },

                // 明细报表
                {
                    path: '/consignor/detailedReport',
                    name: 'detailedReport',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/waybill/detailed-report'], resolve),
                },
                // 汇总报表
                {
                    path: '/consignor/summaryReport',
                    name: 'summaryReport',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/summary-report'], resolve),
                },
                // -安全管理-预警管理
                // 证件预警
                {
                    path: '/consignor/certificateEarlyWarning',
                    name: 'certificateEarlyWarning',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/security/consignor-certificate-warning'], resolve),
                },
                {
                    path: '/consignor/subCertificateWarning',
                    name: 'subCertificateWarning',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/security/sub-certificate-warning'], resolve),
                },
                // 授信预警
                {
                    path: '/consignor/creditEarlyWarning',
                    name: 'creditEarlyWarning',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/security/credit-early-warning'], resolve),
                },
                {
                    path: '/consignor/quotaUsageReminder',
                    name: 'quotaUsageReminder',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/security/quota-usage-reminder'], resolve),
                },
                // 授权预警
                {
                    path: '/consignor/authorizationAlert',
                    name: 'authorizationAlert',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/security/authorization-alert'], resolve),
                },
                // 开售票管理
                {
                    path: '/consignor/billManagement',
                    name: 'billManagement',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        // require(["@/views/consignor/bill-management"], resolve)
                        require(['@/views/common/ticket-issuing'], resolve),
                },
                // 收付款确认
                {
                    path: '/consignor/collectionAndPayment/:type',
                    name: 'collectionAndPayment',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        // require(["@/views/consignor/collection-payment"], resolve)
                        require(['@/views/common/receipt-and-payment'], resolve),
                },
                // 结算管理-统计分析
                {
                    path: '/consignor/settlementStatisticalAnalysis',
                    name: 'settlementStatisticalAnalysis',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require([
                            '@/views/consignor/settlement-statistical-analysis',
                        ], resolve),
                },
                // 投诉管理-我要投诉
                {
                    path: '/consignor/complaintManagement',
                    name: 'complaintManagement',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/complaintManagement'], resolve),
                },
                // 投诉管理-结果反馈
                {
                    path: '/consignor/complaintManagement',
                    name: 'complaintManagement',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/complaintManagement'], resolve),
                },
                {
                    path: '/consignor/resultFeedback',
                    name: 'resultFeedback',
                    meta: {
                        role: 'CUSTOMER',
                    },
                    component: resolve =>
                        require(['@/views/consignor/resultFeedback'], resolve),
                },
            ],
        },
        {
            path: '/business',
            name: 'business',
            component: resolve => require(['@/views/business/index'], resolve),
            children: [
                {
                    path: '/',
                    redirect: '/business/car-sourse',
                },
                {
                    path: '/business/car-sourse',
                    name: 'car-sourse',
                    component: resolve =>
                        require(['@/views/business/car-sourse'], resolve),
                },
                {
                    path: '/business/supply',
                    name: 'supply',
                    component: resolve => require(['@/views/business/supply'], resolve),
                },
                {
                    path: '/business/supply/detail',
                    name: 'supplyDetail',
                    component: resolve =>
                        require(['@/views/business/supplyDetail'], resolve),
                },
                {
                    path: '/business/route',
                    name: 'route',
                    component: resolve => require(['@/views/business/route'], resolve),
                },
            ],
        },
        {
            path: '/help',
            name: 'help',
            component: resolve => require(['@/views/help/index'], resolve),
            children: [
                {
                    path: '/',
                    redirect: '/help/common-problem',
                },
                {
                    path: '/help/common-problem',
                    name: 'common-problem',
                    component: resolve =>
                        require(['@/views/help/common-problem'], resolve),
                },
                {
                    path: '/help/common-problem/detail',
                    name: 'common-problem/detail',
                    meta: {
                        pathInfo: {
                            path: '/help/common-problem',
                            name: '常见问题',
                            children: true,
                        },
                    },
                    component: resolve => require(['@/views/help/details'], resolve),
                },
                {
                    path: '/help/newbie',
                    name: 'newbie',
                    component: resolve => require(['@/views/help/newbie'], resolve),
                },
                {
                    path: '/help/newbie/detail',
                    name: 'newbie/detail',
                    meta: {
                        pathInfo: {
                            path: '/help/newbie',
                            name: '新手上路',
                            children: true,
                        },
                    },
                    component: resolve => require(['@/views/help/details'], resolve),
                },
                {
                    path: '/help/rules',
                    name: 'rules',
                    component: resolve => require(['@/views/help/rules'], resolve),
                },
                {
                    path: '/help/rules/detail',
                    name: 'rules/detail',
                    meta: {
                        pathInfo: {
                            path: '/help/rules',
                            name: '法律条款与平台规则',
                            children: true,
                        },
                    },
                    component: resolve => require(['@/views/help/details'], resolve),
                },
                {
                    path: '/help/customer-service',
                    name: 'customer-service',
                    component: resolve =>
                        require(['@/views/help/customer-service'], resolve),
                },
                {
                    path: '/help/customer-service/detail',
                    name: 'customer-service/detail',
                    meta: {
                        pathInfo: {
                            path: '/help/customer-service',
                            name: '联系客服',
                            children: true,
                        },
                    },
                    component: resolve => require(['@/views/help/details'], resolve),
                },
            ],
        },
        {
            path: '/platformInfo',
            name: 'platformInfo',
            component: resolve => require(['@/views/platformInfo/index'], resolve),
        },
        {
            path: '/driver-center',
            name: 'driver-center',
            component: resolve => require(['@/views/driver/driver-center'], resolve),
        },
        {
            path: '/consignor-center',
            name: 'consignor-center',
            component: resolve =>
                require(['@/views/consignor/consignor-center'], resolve),
        },
        {
            path: '/404',
            name: '404',
            component: resolve => require(['@/views/404'], resolve),
        },
        {
            path: '*',
            redirect: '/404',
        },
        ...rebuildRoutes,
    ],
});
router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.role) {
        // 判断即将跳转的路由是否带有角色信息，带有就进入下一步判断
        if (store.state.isLogin) {
            // 判断是否登录
            const role = JSON.parse(localStorage.getItem('userInfo')).currentRole; // 获取当前登录角色
            if (to.meta.role !== role) {
                // 判断当前登录角色和路由带的角色是否相同，不同直接跳转404，相同继续下一步
                next({
                    path: '*',
                });
            } else {
                next();
            }
        } else {
            // 如果没有登录， 判断路由是否带有重定向地址， 如果带有就跳转重定向地址，没有直接跳登录
            if (to.meta.redirectUrl) {
                next({
                    path: to.meta.redirectUrl,
                });
            } else {
                next({
                    path: '/login',
                });
            }
        }
    } else {
        next();
    }
});
export default router;
